export default "__VITE_ASSET__BLZgR$OE__"